// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"491df174","513":"688e7242","545":"e1d8ed51"}[chunkId] + ".chunk.js";
};